import { useState } from 'react';
import { CUSTOMERS } from '../../data/customers';

const CustomerCard = ({ customer }) => {
  const [imgError, setImgError] = useState(false);

  const getInitials = (name) => {
    return name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();
  };

  const getColor = (name) => {
    const colors = ['#0B1F3B', '#1E40AF', '#0369A1', '#0F766E', '#4338CA', '#7C3AED', '#C026D3', '#DB2777'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const hasLogo = customer.logo && !imgError;

  return (
    <div className="flex min-w-[170px] h-[72px] items-center justify-center px-4">
      {hasLogo ? (
        <div className="flex items-center justify-center">
          <img
            src={customer.logo}
            alt={customer.name}
            className="max-h-[52px] max-w-[150px] object-contain brightness-110 contrast-110 drop-shadow-[0_0_18px_rgba(96,165,250,0.18)] transition-all duration-300 hover:scale-105 hover:drop-shadow-[0_0_22px_rgba(96,165,250,0.28)]"
            onError={() => setImgError(true)}
          />
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div
            className="flex h-10 w-10 items-center justify-center rounded-full text-xs font-bold text-white shadow-[0_0_18px_rgba(96,165,250,0.18)]"
            style={{ backgroundColor: getColor(customer.name) }}
          >
            {getInitials(customer.name)}
          </div>
          <div className="flex flex-col">
            <span className="whitespace-nowrap text-xs font-bold leading-tight uppercase tracking-[0.22em] text-white">
              {customer.name}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const ScrollingCustomers = () => {
  const duplicatedCustomers = [...CUSTOMERS, ...CUSTOMERS];

  return (
    <section className="tech-grid overflow-hidden border-y border-white/10 bg-[#06101f] py-12" data-testid="customers-section">
      <div className="mx-auto mb-6 max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="text-xs font-mono uppercase tracking-widest text-[#60A5FA]">Our Valued Clients</span>
          <h3 className="mt-2 text-xl font-bold uppercase tracking-tight text-white md:text-2xl">
            Trusted by Industry Leaders
          </h3>
          <p className="mt-1 text-sm text-slate-400">Across Africa, Asia & the Middle East</p>
        </div>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute bottom-0 left-0 top-0 z-10 w-20 bg-gradient-to-r from-[#06101f] to-transparent" />
        <div className="pointer-events-none absolute bottom-0 right-0 top-0 z-10 w-20 bg-gradient-to-l from-[#06101f] to-transparent" />

        <div className="flex items-center animate-scroll-left">
          {duplicatedCustomers.map((customer, index) => (
            <div key={`${customer.id}-${index}`} className="mx-5 flex-shrink-0">
              <CustomerCard customer={customer} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScrollingCustomers;
